









import { defineClassComponent } from '@/hooks'
import { JointComponents } from '../../components'
import { jointGoodsModelProvider } from '../model'

export default defineClassComponent(
  {
    components: JointComponents,
  },
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()
    },
)
